import styled from 'styled-components';

export const Wrapper = styled.a`
  display: inline-flex;
  align-items: center;
  font-weight: 200;
`;
export const Icon = styled.span`
  display: inline-flex;
  align-self: center;
  width: 2.4rem;
  margin-left: 1rem;
`;
